// @flow

import * as React from 'react';
import {InlineLink} from 'sail/InlineLink';
import {defineMessages, useIntl} from 'react-intl';

import {useAccount, useLocation} from 'docs/data';
import {getLoginUrl} from 'docs/util';
import TextBlock from './TextBlock';

const messages = defineMessages({
  loggedOutMessage: {
    id: 'docsApp.stripeShell.loggedOutMessage',
    description:
      'Message shown to users when they try to run a command in the Stripe Shell but have not yet logged in.',
    defaultMessage:
      'You must <LogInLink>log in</LogInLink> to use the Stripe Shell.',
  },
});

type Props = {
  renderOutput: () => React.Node,
  setAllowInput: (boolean) => void,
};

const LogInCheck = ({renderOutput, setAllowInput}: Props): React.Node => {
  const {formatMessage} = useIntl();
  const {location} = useLocation();
  const {account} = useAccount();
  const isLoggedIn = account?.merchant?.isLoggedIn;

  if (isLoggedIn) {
    return renderOutput();
  } else {
    setAllowInput(true);
    return (
      <TextBlock>
        {formatMessage(messages.loggedOutMessage, {
          LogInLink: (label) => (
            <InlineLink
              className="StripeCluiButtonLink"
              href={getLoginUrl({account, returnUrl: location.toString()})}
            >
              {label}
            </InlineLink>
          ),
        })}
      </TextBlock>
    );
  }
};

export default LogInCheck;
